module.exports = __webpack_public_path__ + "Icono_Logistica_126px.png";